<template>
  <div class="content-wrapper-scroll">
    <div class="content-wrapper">
      <div class="row">
        <div class="col-sm-12">
          <div class="card">
            <div class="card-header">
              <h5>Deviated Components</h5>
            </div>
            <div class="card-body">
              <div class="row gutters">
                <div class="col-sm-3">
                  <div class="field-wrapper">
                    <div class="field-placeholder">From Date</div>
                    <input
                      class="form-control form-control-sm"
                      type="date"
                      v-model="meta.from_date"
                    />
                    <span v-if="errors.from_date" class="invalid-feedback">{{
                      errors.from_date[0]
                    }}</span>
                  </div>
                </div>
                <div class="col-sm-3">
                  <div class="field-wrapper">
                    <div class="field-placeholder">To Date</div>
                    <input
                      class="form-control form-control-sm"
                      type="date"
                      v-model="meta.to_date"
                    />
                    <span v-if="errors.to_date" class="invalid-feedback">{{
                      errors.to_date[0]
                    }}</span>
                  </div>
                </div>
                <div class="col-sm-3">
                  <div class="field-wrapper">
                    <Search
                      :class="{ 'is-invalid': errors.department_id }"
                      :customClass="{ 'is-invalid': errors.department_id }"
                      :initialize="meta.department_id"
                      id="department_id"
                      label="department_name"
                      placeholder="Select Department"
                      :data="departments"
                      @input="
                        (departments) => (meta.department_id = departments)
                      "
                    >
                    </Search>
                    <span
                      v-if="errors.department_id"
                      class="invalid-feedback"
                      >{{ errors.department_id[0] }}</span
                    >
                    <div class="field-placeholder">Department</div>
                  </div>
                </div>
                <div class="col-sm-3">
                  <div class="field-wrapper">
                    <Search
                      :class="{ 'is-invalid': errors.functional_id }"
                      :customClass="{ 'is-invalid': errors.functional_id }"
                      :initialize="meta.functional_id"
                      id="functional_id"
                      label="functional_name"
                      placeholder="Select Functional"
                      :data="functionals"
                      @input="
                        (functionals) => (meta.functional_id = functionals)
                      "
                    >
                    </Search>
                    <span
                      v-if="errors.functional_id"
                      class="invalid-feedback"
                      >{{ errors.functional_id[0] }}</span
                    >
                    <div class="field-placeholder">Functional</div>
                  </div>
                </div>
                <div class="col-sm-3">
                  <div class="field-wrapper">
                    <Search
                      :class="{ 'is-invalid': errors.section_id }"
                      :customClass="{ 'is-invalid': errors.section_id }"
                      :initialize="meta.section_id"
                      id="section_id"
                      label="section_name"
                      placeholder="Select Section"
                      :data="sections"
                      @input="(sections) => (meta.section_id = sections)"
                    >
                    </Search>
                    <span v-if="errors.section_id" class="invalid-feedback">{{
                      errors.section_id[0]
                    }}</span>
                    <div class="field-placeholder">Section</div>
                  </div>
                </div>
                <div class="col-sm-3">
                  <div class="field-wrapper">
                    <Search
                      :class="{ 'is-invalid': errors.frequency_id }"
                      :customClass="{ 'is-invalid': errors.frequency_id }"
                      :initialize="meta.frequency_id"
                      id="frequency_id"
                      label="frequency_name"
                      placeholder="Select Frequency"
                      :data="frequencies"
                      @input="
                        (frequencies) => (meta.frequency_id = frequencies)
                      "
                    >
                    </Search>
                    <span v-if="errors.frequency_id" class="invalid-feedback">{{
                      errors.frequency_id[0]
                    }}</span>
                    <div class="field-placeholder">Frequency</div>
                  </div>
                </div>
                <div class="col-sm-6">
                  <div class="input-group field-wrapper">
                    <input
                      class="form-control"
                      type="text"
                      placeholder="Search for Template Name"
                      v-model="meta.search"
                    />
                    <span class="input-group-text">
                      <i class="fas fa-search"></i>
                    </span>
                    &nbsp;
                    <div class="field-placeholder">Template Name</div>
                  </div>
                </div>
              </div>
              <div class="form-actions-footer">
                <div class="text-end">
                  <button type="button" class="btn btn-primary" @click="search">
                    Search
                  </button>
                  <button type="button" class="btn btn-danger" @click="reset">
                    Reset
                  </button>
                  <a
                    target="_blank"
                    :href="
                      $store.getters.pdfUrl +
                      'report/deviated-components?plant_id=' +
                      meta.plant_id +
                      '&from_date=' +
                      meta.from_date +
                      '&to_date=' +
                      meta.to_date +
                      '&department_id=' +
                      meta.department_id +
                      '&functional_id=' +
                      meta.functional_id +
                      '&section_id=' +
                      meta.section_id +
                      '&frequency_id=' +
                      meta.frequency_id +
                      '&search=' +
                      meta.search +
                      '&report_type=PDF'
                    "
                    class="btn btn-success"
                  >
                    PDF
                  </a>
                  <a
                    target="_blank"
                    :href="
                      $store.getters.pdfUrl +
                      'report/deviated-components?plant_id=' +
                      meta.plant_id +
                      '&from_date=' +
                      meta.from_date +
                      '&to_date=' +
                      meta.to_date +
                      '&department_id=' +
                      meta.department_id +
                      '&functional_id=' +
                      meta.functional_id +
                      '&section_id=' +
                      meta.section_id +
                      '&frequency_id=' +
                      meta.frequency_id +
                      '&search=' +
                      meta.search +
                      '&report_type=Excel'
                    "
                    class="btn btn-secondary"
                  >
                    Excel
                  </a>

                   <button
                      type="button"
                      class="btn btn-warning"
                      :disabled="selectedComponents.length === 0"
                      data-bs-toggle="modal"
                      data-bs-target="#multiRemarkModal"
                      @click="openMultiRemarkModal"
                    >
                      Update Remarks
                    </button>

                    <button
                      v-if="['Admin','Super Admin'].includes($store.getters.user?.role?.role_name)"
                      type="button"
                      class="btn btn-info ms-2"
                      :disabled="selectedComponents.length === 0"
                      data-bs-toggle="modal"
                      data-bs-target="#assignUserModal"
                      @click="openAssignUserModal"
                    >
                      Assign User
                    </button>

                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-sm-12">
          <div class="card">
            <div class="card-body">
              <div class="row gutters">
                <div class="col-sm-12">
                  <div class="table-responsive tabletop">
                    <table class="table table-bordered table-striped">
                      <thead>
                        <tr>
                           <th><input type="checkbox" @change="toggleSelectAll" :checked="allSelected" /></th>
                          <th>#</th>
                          <th class="text-center">Action</th>
                          <th>Template Name</th>
                          <th>Equipment</th>
                          <th>Date Time</th>
                          <th>Component Type</th>
                          <th>Check Type</th>
                          <th>Default</th>
                          <th>LCL</th>
                          <th>UCL</th>
                          <th>Value</th>
                          <th>Department</th>
                          <th>User</th>
                          <th>Assigned To</th>
                          <th>Note</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-if="deviated_components.length == 0">
                          <td colspan="9" class="text-center">
                            No records found
                          </td>
                        </tr>
                        <tr
                          v-for="(
                            deviated_component, key
                          ) in deviated_components"
                          :key="key"
                        >
                        <td>
                            <input
                              type="checkbox"
                              :value="deviated_component.user_equipment_component_id"
                              v-model="selectedComponents"
                            />
                          </td>
                          <td>{{ meta.from + key }}</td>
                          <td class="text-center">
                            <button
                              data-bs-toggle="modal"
                              data-bs-target="#remarkModal"
                              @click="addRemark(deviated_component)"
                              class="btn btn-xs btn-primary"
                            >
                              <i class="fa fa-add"></i>
                            </button>
                          </td>
                          <td>{{ deviated_component.template_name }}</td>
                          <td>{{ deviated_component.equipment ? deviated_component.equipment : '' }}</td>
                          <td>{{ deviated_component.date_time }}</td>
                          <td>
                            {{
                              deviated_component.component_type &&
                              deviated_component.component_type.component_type_name
                                ? deviated_component.component_type.component_type_name
                                : ''
                            }}
                          </td>
                          <td>
                            {{
                              deviated_component.check_type &&
                              deviated_component.check_type.check_type_name
                                ? deviated_component.check_type.check_type_name
                                : ''
                            }}
                          </td>
                          <td>{{ deviated_component.default_value }}</td>
                          <td>{{ deviated_component.lcl }}</td>
                          <td>{{ deviated_component.ucl }}</td>
                          <td>{{ deviated_component.value }}</td>
                          <td>
                            {{
                              deviated_component.user_template &&
                              deviated_component.user_template.department &&
                              deviated_component.user_template.department.department_name
                                ? deviated_component.user_template.department.department_name
                                : ''
                            }}
                          </td>
                          <td>
                            {{
                              deviated_component.user_template &&
                              deviated_component.user_template.user &&
                              deviated_component.user_template.user.name
                                ? deviated_component.user_template.user.name
                                : ''
                            }}
                          </td>
                          <td>
                            {{
                              deviated_component.assigned_user &&
                              deviated_component.assigned_user.user &&
                              deviated_component.assigned_user.user.name
                                ? deviated_component.assigned_user.user.name
                                : ''
                            }}
                          </td>
                          <td>{{ deviated_component.note }}</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                  <!-- <div class="form-actions-footer">
                    <div class="text-end row">
                      <div class="col-sm-3">
                        <select
                          class="form-control"
                          v-model="meta.per_page"
                          @change="onPerPageChange"
                        >
                          <option>10</option>
                          <option>15</option>
                          <option>20</option>
                          <option>25</option>
                          <option>30</option>
                        </select>
                      </div>
                      <div class="col-sm-10">
                        <Pagination
                          class="pagination pagination-sm"
                          :maxPage="meta.maxPage"
                          :totalPages="meta.lastPage"
                          :currentPage="meta.page"
                          @pagechanged="onPageChange"
                        />
                      </div>
                    </div>
                  </div> -->
                  <div class="form-actions-footer">
                    <div class="text-end row align-items-center">
                      <div class="col-sm-3 d-flex justify-content-center align-items-center">
                        <select class="form-control me-4" v-model="meta.per_page" @change="onPerPageChange">
                          <option>10</option>
                          <option>15</option>
                          <option>20</option>
                          <option>25</option>
                          <option>30</option>
                        </select>

                        <input
                          type="number"
                          class="form-control text-center"
                          style="max-width: 100px;"
                          v-model.number="gotoPage"
                          @keyup.enter="goToEnteredPage"
                          placeholder="Go to page"
                        />
                      </div>

                      <div class="col-sm-9 d-flex justify-content-end">
                        <Pagination
                          class="pagination pagination-sm"
                          :maxPage="meta.maxPage"
                          :totalPages="meta.lastPage"
                          :currentPage="meta.page"
                          @pagechanged="onPageChange"
                        />
                      </div>
                    </div>
                  </div>

                  <div class="modal fade" id="assignUserModal" tabindex="-1">
                    <div class="modal-dialog">
                      <div class="modal-content">
                        <div class="modal-header">
                          <h5 class="modal-title">Assign User</h5>
                          <button class="btn-close" data-bs-dismiss="modal"></button>
                        </div>

                        <div class="modal-body">
                          <div class="field-wrapper">
                            <div class="field-placeholder">User *</div>
                            <select
                              class="form-control"
                              v-model="assignUser.user_id"
                              :class="{ 'is-invalid': errors.user_id }"
                            >
                              <option value="">Select User</option>
                              <option
                                v-for="user in plantUsers"
                                :key="user.user_id"
                                :value="user.user_id"
                              >
                                {{ user.name }}
                              </option>
                            </select>
                            <span v-if="errors.user_id" class="invalid-feedback">
                              {{ errors.user_id[0] }}
                            </span>
                          </div>
                        </div>

                        <div class="modal-footer">
                          <button class="btn btn-secondary" data-bs-dismiss="modal">Close</button>
                          <button class="btn btn-primary" @click="assignUserToComponent">
                            Assign
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>


                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="modal fade" id="remarkModal" tabindex="-1">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">Update Remark</h5>
            <button
              type="button"
              class="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
            ></button>
          </div>
          <div class="modal-body">
            <div class="field-wrapper">
              <div class="field-placeholder">Remark *</div>
              <textarea
                class="form-control"
                v-model="remark.remark"
                :class="{ 'is-invalid': errors.remark }"
                placeholder="Enter Remark"
              ></textarea>
              <span v-if="errors.remark" class="invalid-feedback">{{
                errors.remark[0]
              }}</span>
            </div>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-secondary"
              data-bs-dismiss="modal"
            >
              Close
            </button>
            <button
              type="button"
              @click="updateRemark()"
              class="btn btn-primary"
              data-bs-dismiss="modal"
            >
              Update
            </button>
          </div>
        </div>
      </div>
    </div>

    <!-- Multiplw -->
     <div class="modal fade" id="multiRemarkModal" tabindex="-1">
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title">Update Remarks</h5>
        <button
          type="button"
          class="btn-close"
          data-bs-dismiss="modal"
          aria-label="Close"
        ></button>
      </div>
      <div class="modal-body">
        <div class="field-wrapper">
          <div class="field-placeholder">Remark *</div>
          <textarea
            class="form-control"
            v-model="multiRemark"
            :class="{ 'is-invalid': errors.multiRemark }"
            placeholder="Enter Remarks"
          ></textarea>
          <span v-if="errors.multiRemark" class="invalid-feedback">{{ errors.multiRemark[0] }}</span>
        </div>
      </div>
      <div class="modal-footer">
        <button
          type="button"
          class="btn btn-secondary"
          data-bs-dismiss="modal"
        >
          Close
        </button>
        <button
          type="submit"
          @click="updateMultipleRemarks"
          class="btn btn-primary"

        >
          Update
        </button>
      </div>
    </div>
  </div>
</div>

  </div>
</template>
<script>
import Pagination from "@/components/Pagination.vue";
import Search from "@/components/Search.vue";
export default {
  components: { Pagination, Search },
  data() {
    return {
      meta: {
        plant_id: this.$store.getters.user.plant_id,
        from_date: "",
        to_date: "",
        department_id: "",
        functional_id: "",
        section_id: "",
        frequency_id: "",
        search: "",
        report_type: "Data",
        order_by: "asc",
        field: "user_equipment_component_id",
        per_page: 10,
        totalRows: 0,
        page: 1,
        lastPage: 1,
        from: 1,
        maxPage: 1,
      },
      gotoPage: null,
      remark: {
        user_id: this.$store.getters.user?.user_id,
        user_equipment_component_id: "",
        remark: "",
      },
      plantUsers: [],
      assignUser: {
        user_id: "",
      },
      deviated_components: [],
      departments: [],
      functionals: [],
      sections: [],
      frequencies: [],
      errors: [],
       selectedComponents: [],
    multiRemark: "",
    allSelected: false,
    };
  },
  mounted() {
    let vm = this;
    vm.getDepartment();
  },
  watch: {
  selectedComponents() {
    this.allSelected = this.deviated_components.length > 0 &&
      this.deviated_components.every(dc =>
        this.selectedComponents.includes(dc.user_equipment_component_id)
      );
  }
},

  methods: {
    index() {
      let vm = this;
      if(vm.$store.getters.meta)
      {
        vm.meta = vm.$store.getters.meta;
        console.log('setLogaaaaa', vm.$store.getters.meta)
      }
      let loader = vm.$loading.show();
      vm.$store
        .dispatch("post", { uri: "report/deviatedComponents", data: vm.meta })
        .then(function (response) {
          loader.hide();
          vm.deviated_components = response.data.data;
          vm.meta.totalRows = response.data.meta.total;
          vm.meta.lastPage = response.data.meta.last_page;
          vm.meta.from = response.data.meta.from;
          vm.meta.maxPage = vm.meta.lastPage >= 3 ? 3 : vm.meta.lastPage;

          // Check if all components on current page are selected
          vm.allSelected = vm.deviated_components.every(dc =>
            vm.selectedComponents.includes(dc.user_equipment_component_id)
          );
        })
        .catch(function (error) {
          loader.hide();
          vm.errors = error.response.data.errors;
          vm.$store.dispatch("error", error.response.data.message);
        });
    },
    openAssignUserModal() {
      this.assignUser.user_id = "";
      this.errors = {};
      this.getPlantUsers();
    },

    getPlantUsers() {
      let vm = this;
      let loader = vm.$loading.show();

      vm.$store
        .dispatch("post", { uri: "getPlantUsers", data: vm.meta })
        .then((response) => {
          loader.hide();
          vm.plantUsers = response.data.data;
        })
        .catch((error) => {
          loader.hide();
          vm.errors = error.response?.data?.errors || {};
        });
    },
    assignUserToComponent() {
			let vm = this;
			vm.errors = {};

			// Validate user_id is required
			if (!vm.assignUser.user_id || vm.assignUser.user_id === '' || vm.assignUser.user_id === null) {
				vm.errors.user_id = ["User is required."];
				return;
			}

			// Validate at least one component is selected
			if (vm.selectedComponents.length === 0) {
				vm.$store.dispatch("error", "Please select at least one component.");
				return;
			}

			const loader = vm.$loading.show();
			
			// Send user_id and array of user_equipment_component_id
			vm.$store
				.dispatch("post", {
					uri: "assignUserToComponent",
					data: {
						user_id: vm.assignUser.user_id,
						user_equipment_component_ids: vm.selectedComponents
					}
				})
				.then(() => {
					loader.hide();
					vm.assignUser.user_id = '';
					vm.assignUser.user_equipment_component_id = '';
					vm.selectedComponents = [];
					vm.allSelected = false;
					vm.$store.dispatch("success", "User assigned successfully.");
					
					// Close the modal by triggering the close button
					vm.$nextTick(() => {
						const modalEl = document.getElementById('assignUserModal');
						if (modalEl) {
							const closeButton = modalEl.querySelector('button[data-bs-dismiss="modal"]');
							if (closeButton) {
								closeButton.click();
							} else {
								// Fallback: use Bootstrap modal API
								if (window.bootstrap && window.bootstrap.Modal) {
									const modalInstance = window.bootstrap.Modal.getInstance(modalEl);
									if (modalInstance) {
										modalInstance.hide();
									}
								} else {
									// Manual fallback
									modalEl.classList.remove('show');
									modalEl.setAttribute('aria-hidden', 'true');
									modalEl.style.display = 'none';
									document.body.classList.remove('modal-open');
									document.querySelectorAll('.modal-backdrop').forEach(el => el.remove());
								}
							}
						}
					});
					
					vm.index();
				})
				.catch((error) => {
					loader.hide();
					vm.errors = error.response?.data?.errors || {};
					vm.$store.dispatch(
						"error",
						error.response?.data?.message || "An error occurred"
					);
				});
		},

    getDepartment() {
      let vm = this;
      vm.$store
        .dispatch("post", { uri: "getDepartmentsPlantWise", data: vm.meta })
        .then(function (response) {
          vm.departments = response.data.data;
          vm.getFunctions();
        })
        .catch(function (error) {
          vm.errors = error.response.data.errors;
          vm.$store.dispatch("error", error.response.data.message);
        });
    },

    getFunctions() {
      let vm = this;
      vm.$store
        .dispatch("post", { uri: "getFunctionalsPlantWise", data: vm.meta })
        .then(function (response) {
          vm.functionals = response.data.data;
          vm.getSections();
        })
        .catch(function (error) {
          vm.errors = error.response.data.errors;
          vm.$store.dispatch("error", error.response.data.message);
        });
    },

    getSections() {
      let vm = this;
      vm.$store
        .dispatch("post", { uri: "getSectionsPlantWise", data: vm.meta })
        .then(function (response) {
          vm.sections = response.data.data;
          vm.getFrequencies();
        })
        .catch(function (error) {
          vm.errors = error.response.data.errors;
          vm.$store.dispatch("error", error.response.data.message);
        });
    },

    getFrequencies() {
      let vm = this;
      vm.$store
        .dispatch("post", { uri: "getFrequenciesPlantWise", data: vm.meta })
        .then(function (response) {
          vm.frequencies = response.data.data;
        })
        .catch(function (error) {
          vm.errors = error.response.data.errors;
          vm.$store.dispatch("error", error.response.data.message);
        });
    },

    addRemark(user_equipment_component) {
      let vm = this;
      vm.remark.user_equipment_component_id =
        user_equipment_component?.user_equipment_component_id;
      vm.remark.remark = user_equipment_component?.remark;
    },
    toggleSelectAll1(event) {
    if (event.target.checked) {
      this.selectedComponents = this.deviated_components.map(
        (item) => item.user_equipment_component_id
      );
    } else {
      this.selectedComponents = [];
    }
    },
  toggleSelectAll(event) {
  if (event.target.checked) {
    this.selectedComponents.push(
      ...this.deviated_components
        .map(item => item.user_equipment_component_id)
        .filter(id => !this.selectedComponents.includes(id)) // avoid duplicates
    );
  } else {
    this.selectedComponents = this.selectedComponents.filter(
      id => !this.deviated_components.some(dc => dc.user_equipment_component_id === id)
    );
  }

  this.allSelected = event.target.checked;
},


    openMultiRemarkModal() {
      this.multiRemark = "";
      this.errors.multiRemark = null;
    },

    updateMultipleRemarks() {
      let vm = this;
      vm.errors = {};

      if (!vm.multiRemark.trim()) {
        vm.errors.multiRemark = ["Remark is required."];
        return;
      }

      if (vm.selectedComponents.length === 0) {
        vm.$store.dispatch("error", "Please select at least one component.");
        return;
      }

      // Get full objects for selected components
      const selectedObjects = vm.deviated_components.filter(dc =>
        vm.selectedComponents.includes(dc.user_equipment_component_id)
      );

      let payload = {
        deviated_components: selectedObjects,
        remark: vm.multiRemark.trim(),
        user_id: vm.$store.getters.user?.user_id,
      };

      let loader = vm.$loading.show();
      vm.$store
        .dispatch("post", { uri: "bulkupdateDeviatedRemarks", data: payload })
        .then(() => {
          loader.hide();
          vm.selectedComponents = [];
          vm.multiRemark = "";
          vm.allSelected = false;
          vm.$store.dispatch("success", "Remarks updated successfully.");
          vm.index();

          vm.$nextTick(() => {
            const modalEl = document.getElementById('multiRemarkModal');
            if (modalEl) {
              if (window.bootstrap && window.bootstrap.Modal) {
                const modalInstance = window.bootstrap.Modal.getInstance(modalEl);
                if (modalInstance) {
                  modalInstance.hide();
                } else {
                  modalEl.classList.remove('show');
                  modalEl.setAttribute('aria-hidden', 'true');
                  modalEl.style.display = 'none';
                  document.body.classList.remove('modal-open');
                  document.querySelectorAll('.modal-backdrop').forEach(el => el.remove());
                }
              } else {
                modalEl.classList.remove('show');
                modalEl.setAttribute('aria-hidden', 'true');
                modalEl.style.display = 'none';
                document.body.classList.remove('modal-open');
                document.querySelectorAll('.modal-backdrop').forEach(el => el.remove());
              }
            }
            
            setTimeout(() => {
              document.body.classList.remove('modal-open');
              document.body.style.overflow = '';
              document.body.style.paddingRight = '';
              document.querySelectorAll('.modal-backdrop').forEach(el => el.remove());
            }, 100);
          });
        })
        .catch((error) => {
          loader.hide();
          vm.errors = error.response?.data?.errors || {};
          vm.$store.dispatch("error", error.response?.data?.message || "An error occurred");
        });
    },

    updateRemark() {
      let vm = this;
      let loader = vm.$loading.show();
      vm.$store.dispatch('setMeta', vm.meta)
      console.log('setLog', vm.$store.getters.meta)
      let uri = { uri: "updateDeviatedRemarks", data: vm.remark };
      vm.$store
        .dispatch("post", uri)
        .then(function () {
          loader.hide();
          vm.remark.user_equipment_component_id = "";
          vm.remark.remark = "";
          vm.$store.dispatch("success", "Remark is successfully updated");
          // vm.reset();

          vm.index();
        })
        .catch(function (error) {
          loader.hide();
          vm.errors = error.response.data.errors;
          vm.$store.dispatch("error", error.response.data.message);
        });
    },

    onPageChange(page) {
      this.meta.page = page;
      this.index();
    },
    onPerPageChange() {
      this.meta.page = 1;
      this.index();
    },
    goToEnteredPage() {
      if (this.gotoPage && this.gotoPage >= 1 && this.gotoPage <= this.meta.lastPage) {
        this.meta.page = this.gotoPage;
        this.index();
      } else {
        alert(`Please enter a valid page between 1 and ${this.meta.lastPage}`);
      }
    },
    sort(field) {
      this.meta = field;
      this.meta.order_by = this.meta.order_by == "asc" ? "desc" : "asc";
      this.index();
    },
    search() {
      this.meta.page = 1;
      this.index();
    },

    reset() {
      let vm = this;
      vm.meta.from_date = "";
      vm.meta.to_date = "";
      vm.meta.department_id = "";
      vm.meta.functional_id = "";
      vm.meta.section_id = "";
      vm.meta.frequency_id = "";
      vm.meta.search = "";
      vm.errors = [];
      // vm.search();
    },
  },
};
</script>

<style scoped>
.btnn {
  margin-top: 0.5rem;
}
</style>
